<!-- ==============================
  File Name: PartnerList.vue
  Description: Partner List page
=============================== -->

<template>
<div id="page-user-list">
<div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line class='font-20' icon="UsersIcon" statistic="Partners" :statisticTitle="totalPartnerCount" statisticSubTitle="Total" type="area"></statistics-card-line>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line class='font-20' icon="ShoppingBagIcon" statistic="Partners" :statisticTitle="totalActivePartnerCount" statisticSubTitle="Active"  color="warning"  type="area"></statistics-card-line>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line class='font-20' icon="UsersIcon" statistic="Codes" :statisticTitle="totalActiveCodeCount" statisticSubTitle="Active" type="area"></statistics-card-line>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line class='font-20' icon="ShoppingBagIcon" statistic="Clients" :statisticTitle="totalActiveClientCount" statisticSubTitle="Active" color="warning" type="area"></statistics-card-line>
      </div>
  </div>
    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ partnersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : partnersData.length }} of {{ partnersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
            <vs-button @click.prevent="redirectToAddPartner">Add Partner</vs-button>
      </div>


      <!-- Partner List Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 h-610 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="partnersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import vSelect from 'vue-select'
import VueApexCharts from 'vue-apexcharts'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from '../../../ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import VxTimeline from '@/components/timeline/VxTimeline'
import * as moment from 'moment-timezone';

// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

// Cell Renderer
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import CellRendererClients from './cell-renderer/CellRendererClients.vue'
import PartnerService from "@/services/PartnerService";
import PartnerCodesService from "@/services/PartnerCodesService";
import ClientService from "@/services/ClientService";
import UtilService from "@/services/UtilService";

export default {
  components: {
    AgGridVue,
    vSelect,
    // Cell Renderer
    CellRendererStatus,
    CellRendererActions,
    CellRendererClients,
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline,
  },
  data () {
    return {
      // Filter Options
      totalActiveClientCount: 0,
      totalActiveCodeCount: 0,
      totalPartnerCount:0,
      totalActivePartnerCount:0,
      subscribersGained: {},
      partners: [],
      roleFilter: { label: 'All', value: 'all' },
      searchQuery: '',
      userZone: '',
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: "Created Date",
          field: "CreatedDate",
          width: 160,
          filter: true,
          sortable: true,
          sort: ['desc'],
          cellRenderer: (data) => {
            
            // return data.value;

            var date = data.value.slice(0,-3);

            const tzid = Intl.DateTimeFormat().resolvedOptions().timeZone;

            var created_at = moment(date).tz(tzid).format('YYYY-MM-DD HH:mm:ss');
            // console.log(created_at);
            return created_at;
          }
        },
        {
				headerName: "Primary Code",
				field: "PrimaryCode",
				filter: true,
				width: 175,
                checkboxSelection: false,
                headerCheckboxSelectionFilteredOnly: false,
                headerCheckboxSelection: false
				},
				{
				headerName: "Company",
				field: "CompanyName",
				filter: true,
				width: 175
				},
				{
				headerName: "City",
				field: "City",
				filter: true,
				width: 175
				},
        {
				headerName: "Phone",
				field: "Phone",
				filter: true,
				width: 175
				},
				{
				headerName: "GST",
				field: "GST",
				filter: true,
				width: 175
				},
				{
				headerName: "Industry",
				field: "Industry",
				filter: true,
				width: 150
				},
				{
				headerName: "Reference",
				field: "Reference",
				filter: true,
				width: 125
				},
				{
				headerName: "Clients",
				field: "ClientCount",
				filter: true,
				width: 140
				},
				{
				headerName: "Codes",
				field: "CodeCount",
				filter: "agNumberColumnFilter",
				width: 140
				},
				{
				headerName: "Joined",
				field: "CreatedDate",
				filter: true,
				width: 150,
        },
        {
        headerName: "Status",
        field: "Status",
        filter: true,
        width: 150,
        cellRendererFramework: 'CellRendererStatus'
        },
        {
        headerName: 'Actions',
        field: 'transactions',
        width: 100,
        cellRendererFramework: 'CellRendererActions'
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererStatus,
        CellRendererActions,
        CellRendererClients,
        StatisticsCardLine,
      }
    }
  },
  watch: {
    roleFilter (obj) {
      this.setColumnFilter('Role', obj.value)
    },
    statusFilter (obj) {
      this.setColumnFilter('Status', obj.value)
    },
    isVerifiedFilter (obj) {
      const val = obj.value === 'all' ? 'all' : obj.value === 'yes' ? 'true' : 'false'
      this.setColumnFilter('is_verified', val)
    },
    departmentFilter (obj) {
      this.setColumnFilter('department', obj.value)
    }
  },
  computed: {
     partnersData () {
      return this.partners
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    redirectToAddPartner() {
         this.$router.push('/apps/partners/add');
    },
    getPartners() {
      if(this.userInfo){
        PartnerService.getAll(this.userInfo).on("value", (items) => {
          this.partners = [];
          let Partners = [];
          this.totalPartnerCount = 0
          this.totalActivePartnerCount = 0
          items.forEach((item) => {
            let key = item.key;
            let data = item.val();
               if(data['IsDeleted'] == 0){
                data['CreatedDate'] = data['CreatedDate'] //UtilService.convertUTCToCurrentZone(data['CreatedDate'],this.userZone);
                data['ClientCount'] = data['ClientCount'] ? data['ClientCount']: 0
                data['CodeCount'] = data['CodeCount'] ? data['CodeCount']: 0
                this.totalPartnerCount += 1;
                Partners.push({...data});
              if(data['Status']=='Active' || data['IsActive']==1){
                this.totalActivePartnerCount += 1;
              }
            }
          });
           this.partners =  Partners.sort(function(a,b){
           return new Date(b.ModifiedDate) - new Date(a.ModifiedDate)
          });
  
        });
      }
    },
      getPartnerCodes() {
       if(this.userInfo){
         PartnerCodesService.getAll(this.userInfo).on("value", (items) => {
           this.totalInActiveCodeCount = 0;
           items.forEach((item) => {
             let key = item.key;
             let data = item.val();
             if(data['IsDeleted'] == 0){
                 if(data['Status']=='Active' || data['IsActive']==1){
                 this.totalActiveCodeCount += 1;
               }
             }
           }); 
         });
       }
    },
     getClients() {
      if (this.userInfo) {
        ClientService.getAll(this.userInfo).on("value", items => {
          this.totalActiveClientCount = 0;
          items.forEach(item => {
            let key = item.key;
            let data = item.val();
            if (data["IsDeleted"] == 0) {
              if (data["Status"] == "Active" || data["IsActive"] == 1) {
                this.totalActiveClientCount += 1;
              }
            }
          });
        });
      }
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  created () {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
    this.userZone = this.userInfo.Timezone;
    this.getPartners();
    this.getPartnerCodes();
    this.getClients();
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.h-610{
  height: 610px;
}
.font-20{
    font-size: 20px;
  }
</style>
